module.exports = __webpack_public_path__ + "img/Kelvin.b9f50e2a.jpeg";